import TreeView from "@material-ui/lab/TreeView";
import flattenHierarchy from "backend/flattenHierarchy";
import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import ElementTreeViewItem from "./ElementTreeViewItem";

const useElementTreeViewStyles = makeThemedStyles(
  "ElementTreeView",
  (theme) => ({
    root: {
      margin: "0px",
      "& svg path": {
        fill: "#162870",
      },
    },
  })
);

const ElementTreeView = (
  props: React.PropsWithChildren<{
    selectedItem?: ICardElementWithChildren;
    items: ICardElementWithChildren[];
    type?: "elementtreeview" | "workflowadmin";
    onSelected?: (items: ICardElementWithChildren) => void;
  }>
) => {
  const { selectedItem } = props;
  const styles = useElementTreeViewStyles();
  const flatItems = React.useMemo(
    () => flattenHierarchy(props.items),
    [props.items]
  );
  const [expanded, setExpanded] = React.useState<string[]>([]);
  const [selected, setSelected] = React.useState<string[]>(
    selectedItem ? [selectedItem.id] : []
  );
  const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (
    event: React.ChangeEvent<{}>,
    nodeIds: string | string[]
  ) => {
    if (typeof nodeIds === "string") {
      setSelected([nodeIds]);

      if (props.onSelected) {
        const [selectedItem] = flatItems.filter((item) => item.id === nodeIds);
        if (selectedItem) {
          props.onSelected(selectedItem);
        }
      }
    }
  };

  return (
    <TreeView
      className={styles.root}
      classes={styles}
      defaultCollapseIcon={null}
      defaultExpandIcon={null}
      expanded={flattenHierarchy(props.items).map((item) => item.id)}
      selected={selected}
      onNodeToggle={handleToggle}
      onNodeSelect={handleSelect}
    >
      {props.items.map((item) => (
        <ElementTreeViewItem key={item.id} item={item} rootLevel={true} />
      ))}
    </TreeView>
  );
};

export default ElementTreeView;
